import { get,post } from "../ajax";

interface saveSupplyProductType {
    id: string | number,
    productName: string,
    parvalue: number,
    productPrice: number,
    riskAmount: number,
    status: number,
    productType: number,
    innerProductId: string,
}

export interface SupplyProductType {
   key: string,
   value: number | string,
   description: string 
}

export interface activityListType {
    activityId: number,
    activityName: string,
}


export async function supplyProduct(body:Record<string, any>){
    const url = `/api/SupplyProduct/GetProductPageList?ProductName=${body.ProductName}&PageIndex=${body.PageIndex}&PageSize=${body.PageSize}`
    const res = await get(url)
    return res;
}

export async function supplyProductTypes(){
    const url = `/api/SupplyProduct/GeSupplyProductTypes`
    const res = await get(url)
    return res;
}

export async function saveSupplyProduct(body:saveSupplyProductType){
    const url = `/api/SupplyProduct/SaveProduct`
    const res = await post(url,body)
    return res;
}

export async function changeSupplyProductStatus(body:{supplyProductId:number,status:number}){
    const url = `/api/SupplyProduct/SaveProductStatus`
    const res = await post(url,body)
    return res;
}